'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { Paragraph } from '../ui/paragraph';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { SignInDialog } from "@eliadmin/core/src/components/dialog/lazy-dialogs";
import { Heading } from '../ui/heading';

export function SignInFormCart() {
  const { t } = useTranslations();

  const openDialog = useDialogStore(s => s.open);

  const handleSignInClick = () => {
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog inCart />,
    });
  };

  return (
    <div className="col-span-12 flex w-full flex-col items-start justify-start gap-3 rounded-[4px] bg-[#FAE9CE] p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4 lg:gap-8">
      <div className="flex w-full flex-col items-start justify-start gap-2">
        <Heading title={t('text3412')} tag="h6" />
        <Paragraph size="base" className="w-full text-left" color="black">
          {t('text3413')}
        </Paragraph>
      </div>
      <Button onClick={handleSignInClick} className="h-10 w-full whitespace-nowrap px-3 sm:w-fit">
        {t('text189')}
      </Button>
    </div>
  );
}
